(function () {
  var el = document.getElementById('theme-globals');
  if (!el) return;
  var d = JSON.parse(el.textContent);
  window.cartJSON = d.cartJSON;
  window.routes = d.routes;
  window.cartStrings = d.cartStrings;
  window.variantStrings = d.variantStrings;
  window.productStrings = d.productStrings;
  window.accessibilityStrings = d.accessibilityStrings;
  window.bundleStrings = d.bundleStrings;
  window.breakpoints = d.breakpoints;
  window.settings = d.settings;
  window.default_currency = d.default_currency;
  window.money_format = d.money_format;
  window.money_with_currency_format = d.money_with_currency_format;
  if (d.b2b) window.B2B = true;
})();
